export class Patient {
    
    firstName: string;
    lastName: string;
    dob: number;
    dobStr: string;
    email: string;
    phone: number;
    active: boolean;
    chiefComplaint: string;
    hospitalSurgeonId: string;
    hospitalPracticeId: number;
    imagePath: string;
    gender: string;
    createdDateObj: number;
    createdDate: string;
    createdBy: number;
    age: number;
    patientStatus: string;
    surgeonId: string;
    surgeonFirstName: string;
    surgeonLastName: string;
    surgeonName: string;
    serviceLocId: string;
    serviceLocName: string;
    location: string;
    currentStageName: string;
    patientFk: number;
    title: string;
    patientSWId: string;
    dosObj: string;
    notes:string;
    patientGroup:string;
    payorType: string;
    patientHspId: string;
    hspDischargeDate: string;
    snfDischargeDate: string;
    patientSnfStatus: boolean;
    workflowMode: string;
    hospitalId: number;
    dos: string;
    cjr: string;
    ID: number;
  }
  